import { useState } from "react";
import { Helmet } from "react-helmet";
import { CgSpinner } from "react-icons/cg";
import { Link } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Header from "../../components/navbar/Header";

function Truevalue() {
  const [phone, setPhone] = useState("");
  const [, setEmail] = useState("");
  const [, setName] = useState("");
  const [, setServiceType] = useState(""); // Buy a Car / Sell a Car
  const [loading, setLoading] = useState(false);

  const pattern = /^[6-9][0-9]{9}$/;

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    // Firebase code commented for now
    // try {
    //   await addDoc(collection(db, "ptruevalues"), {
    //     name,
    //     email,
    //     phone,
    //     serviceType,
    //     timestamp: dateTime,
    //   });
    //   navigate("/thank-you");
    // } catch (error) {
    //   toast.error("Something went wrong");
    // }

    setLoading(false);
  }

  return (
    <>
      <Helmet>
        <title>
          Maruti Suzuki True Value in Hyderabad | Buy & Sell Certified Used Cars
        </title>
        <meta
          name="description"
          content="Maruti Suzuki True Value Showroom in Hyderabad. Buy & Sell used cars in Hyderabad."
        />
      </Helmet>

      <Header />

      <img
        src={require("../../assets/banners-2/Web-Banners-True-value.webp")}
        className="w-full lg:h-[550px] object-cover"
        loading="lazy"
        alt="truevalue banner"
      />

      <div className="shadow sm:px-0 px-4">
        <p className="mx-auto container py-4">
          <Link to="/">Home</Link> / Truevalue
        </p>
      </div>

      <div className="container mx-auto py-16 px-5">
        <p className="text-red-500 font-semibold text-2xl">
          Sell or Buy Car by Contacting Us
        </p>

        <form onSubmit={handleSubmit} className="mt-5 space-y-3">
          <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                className="border h-10 outline-none px-3 rounded-md w-full"
                type="text"
                required
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                className="border h-10 outline-none px-3 rounded-md w-full"
                type="text"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone <span className="text-red-500">*</span>
              </label>
              <input
                className="border h-10 outline-none px-3 rounded-md w-full"
                type="text"
                maxLength="10"
                minLength="10"
                required
                value={phone}
                onChange={(e) =>
                  setPhone(e.target.value.replace(/[^0-9]/g, ""))
                }
              />
              {!pattern.test(phone) && phone.length === 10 && (
                <small className="text-red-500">Phone number is invalid</small>
              )}
            </div>

            {/* Service Type Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Select Service <span className="text-red-500">*</span>
              </label>

              <select
                required
                onChange={(e) => setServiceType(e.target.value)}
                className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm"
              >
                <option value="">-- Select an Option --</option>
                <option value="Buy a Car">Buy a Car</option>
                <option value="Sell a Car">Sell a Car</option>
              </select>
            </div>
          </div>

          {/* Disclaimer */}
          <p className="text-gray-700">
            <span className="text-black font-bold">Disclaimer</span>: I agree
            that by clicking the ‘Submit’ button below, I am explicitly
            soliciting a call/message from Gem Motor Pvt. Ltd.
          </p>

          <div className="flex items-start">
            <input
              id="disclaimer"
              name="disclaimer"
              type="checkbox"
              required
              className="h-4 w-4 rounded"
            />
            <label
              htmlFor="disclaimer"
              className="ml-2 text-sm font-medium text-gray-700"
            >
              Please agree with the following disclaimer
            </label>
          </div>

          {/* Submit Button */}
          <button
            className="bg-[#1D3A8A] hover:bg-red-500 duration-500 text-white rounded py-2.5 px-5"
            type="submit"
            disabled={!pattern.test(phone)}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <CgSpinner className="animate-spin h-5 mr-2 w-5" />
                Loading
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>

      <Footer />
    </>
  );
}

export default Truevalue;
